import { IDosageValueModel } from "./dosage-value.model";

export interface IDosageModel {
	dosageId: number;
	customerId: number;
	appointmentId?: number;
	// The pool/spa this was recorded on. Null on records that predate the Assets tab.
	structureId?: number;
	dosageDate: Date;
	dosageValues: IDosageValueModel[];
}

export class DosageModel implements IDosageModel {
	constructor() {
		this.dosageId = 0;
		this.dosageValues = [];
	}
	dosageId: number;
	customerId: number;
	appointmentId?: number;
	// The pool/spa this was recorded on. Null on records that predate the Assets tab.
	structureId?: number;
	dosageDate: Date;
	dosageValues: IDosageValueModel[];
}
